import type Phaser from "phaser";
import { ANIMATION_ASSETS, BOOT_SHEETS, STATIC_ASSETS } from "./catalog";

const ASSET_ROOT = "assets";

export function loadBootAssets(scene: Phaser.Scene): void {
  for (const sheet of BOOT_SHEETS) {
    scene.load.spritesheet(sheet.key, `${ASSET_ROOT}/${sheet.file}`, {
      frameWidth: sheet.frameWidth,
      frameHeight: sheet.frameHeight,
    });
  }
  scene.load.image("logo-hibernation-run", `${ASSET_ROOT}/exports/ui/logo-hibernation-run.png`);
  scene.load.image("menu-background", `${ASSET_ROOT}/exports/ui/menu-background.png`);
  scene.load.image("panel-large", `${ASSET_ROOT}/exports/ui/panel-nine-slice-large.png`);
}

export function loadGameAssets(scene: Phaser.Scene): void {
  for (const asset of ANIMATION_ASSETS) {
    scene.load.spritesheet(asset.key, `${ASSET_ROOT}/${asset.file}`, {
      frameWidth: asset.frameWidth,
      frameHeight: asset.frameHeight,
    });
  }
  for (const asset of STATIC_ASSETS) {
    if (!scene.textures.exists(asset.key)) {
      scene.load.image(asset.key, `${ASSET_ROOT}/${asset.file}`);
    }
  }
}

export function createAnimations(scene: Phaser.Scene): void {
  for (const asset of ANIMATION_ASSETS) {
    if (scene.anims.exists(asset.key)) {
      scene.anims.remove(asset.key);
    }
    scene.anims.create({
      key: asset.key,
      frames: scene.anims.generateFrameNumbers(asset.key, {
        start: 0,
        end: asset.frameCount - 1,
      }),
      frameRate: asset.frameRate,
      repeat: asset.loop ? -1 : 0,
    });
  }
}

export function assetOrigin(key: string, frameIndex = 0): { x: number; y: number } {
  const anim = ANIMATION_ASSETS.find((item) => item.key === key);
  if (anim) {
    const x = anim.frameOriginX?.[frameIndex] ?? anim.origin.x;
    return { x, y: anim.origin.y };
  }
  const stat = STATIC_ASSETS.find((item) => item.key === key);
  return stat?.origin ?? { x: 0.5, y: 0.5 };
}

export function applySpriteOrigin(sprite: Phaser.GameObjects.Sprite): void {
  const key = sprite.anims.currentAnim?.key ?? sprite.texture.key;
  const index = sprite.anims.currentFrame?.index ?? 0;
  const origin = assetOrigin(key, index);
  if (sprite.originX !== origin.x || sprite.originY !== origin.y) {
    sprite.setOrigin(origin.x, origin.y);
  }
}
